import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<PollError @error={{@model}} />",{ moduleName: "@croodle/client/templates/poll-error.hbs" })